/* eslint-disable no-hardcoded-strings/no-hardcoded-strings */
import { colors } from '@/colors';

interface IInfoIconProps {
  cursorPointer?: boolean;
}

export const InfoIcon = ({ cursorPointer = false }: IInfoIconProps) => {
  return (
    <div
      style={{
        cursor: cursorPointer ? 'pointer' : 'unset',
        fontWeight: 'bold',
        color: colors.white,
        borderRadius: '50%',
        width: 20,
        height: 20,
        minWidth: 20,
        minHeight: 20,
        backgroundColor: colors.info,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      i
    </div>
  );
};
